export default __webpack_public_path__ + "static/media/arco-ajuda.7a7979a5.webp";